<template>
  <aw-drag
    v-if="edit || element.children?.length || publicUpload"
    :enable="edit"
    :drag-item="element"
    #default="{ dragHandle }"
    class="DocumentBlock -image"
    :class="{
      DocumentHasPlaceholder: element.placeholder,
      isCommentOpened: isCommentOpened,
      DocumentHighlightSearch: $route.hash === '#el' + element.id
    }"
    :id="'el' + element.id"
  >
    <div class="DocumentElement -image">
      <div
        class="w-full bg-bc-blue flex flex-row justify-center space-x-2 p-4"
        v-if="element.locked && !isEveryElementLocked && !isPageLocked"
      >
        <aw-icon icon="lock" class="w-5 h-5 text-white" />
        <span class="text-white text-sm">Element is locked</span>
      </div>

      <document-upload-drop-zone
        :upload-enabled="draggedElement === null && !dragged"
        :visible="edit || publicUpload"
        :public-upload="publicUpload"
        v-model="element"
        v-model:modelChildren="children"
        :key="element.key"
      >
        <template v-for="(image, index) in imageList" :key="image.key">
          <document-element-image-file
            :element="image"
            :parent="element"
            :page="page"
            @on-prev-image="prevImage()"
            @on-next-image="nextImage()"
            @on-open-image="openGallery(element.id, image.file ? image.file : image.file_upload)"
            :class="{
              DocumentElementDragged: image.dragged,
              'mt-2': index > 0
            }"
          />
        </template>
      </document-upload-drop-zone>

      <!--  editacni akce  -->
      <div class="DocumentBlock__PanelLeft -image">
        <document-files-actions v-model="element" />
      </div>

      <!-- comments -->
      <document-comment
        v-if="bcDocumentStore.document.allow_comments"
        v-model="element.comments"
        :element="element"
        :document="bcDocumentStore.document"
        @comment-toggle="resolveZindexOnParent"
      />

      <!-- panel s moznosti noveho elementu -->
      <document-hot-action
        :parent="parent"
        :page="page"
        :index="index + 1"
        v-if="edit && !isLastOnPage"
      />
    </div>
    <div class="DocumentBlock__PanelRight -image">
      <span
        ref="DocumentCircle"
        class="DocumentCircle mr-2.5 sm:mr-3.5"
        :class="{
          'DocumentCircle--active':
            bcSelectedStore.selected.has(element.id) &&
            bcSelectedStore.selected.get(element.id)[3],
          'DocumentCircle--child-active':
            bcSelectedStore.selected.has(element.id) &&
            !bcSelectedStore.selected.get(element.id)[3]
        }"
        :data-item-index="element.root_rank"
        @click.prevent.stop="bcSelectedStore.select(
          element, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            isDocument: true,
            itemIndex: element.root_rank,
          }
        )"
      ></span>
      <span
        class="cursor-move text-gray-400 hover:text-gray-500"
        v-if="edit"
        :ref="dragHandle"
      >
        <aw-icon icon="dots" class="w-4 h-4 -mx-1"></aw-icon>
        <aw-icon icon="dots" class="w-4 h-4 -mx-1"></aw-icon>
      </span>
    </div>
  </aw-drag>
</template>

<script>
import FilesElement from '../../mixins/FilesElement'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    FilesElement,
    Selected,
  ],
  allowedChildElements: ['file'],
  props: ['preselectChildren'],
  emits: ['on-prev-image-preview', 'on-next-image-preview'],
  data() {
    return {}
  },
  computed: {
    imageList() {
      return this.preselectChildren
        ? this.preselectChildren
        : this.childrenSorted
    }
  },
  methods: {
    prevImage() {
      this.$emit('on-prev-image-preview')
    },
    nextImage() {
      this.$emit('on-next-image-preview')
    }
  },
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.element)
  },
}
</script>

<style lang="scss" scoped></style>
